import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

export const useDeleteCustomerBo = (customerId: number, userId: number) => {
  const queryClient = useQueryClient();

  const deleteCustomer = async () => {
    await Axios.delete(
      `${DELETE_URL(customerId.toString(), userId.toString()).deleteCustomerIam}`
    );
  };

  return useMutation<void, AxiosError<BaseError>>(deleteCustomer, {
    onSuccess: () => {
      queryClient.invalidateQueries(['customerBoIam', customerId]);
    },
    useErrorBoundary: false
  });
};
